// extracted by mini-css-extract-plugin
export default {"container":"PalletBalancePage_container__7J1vc","loader":"PalletBalancePage_loader__Qvh1d","banner":"PalletBalancePage_banner__ynSnI"};